import { render } from "./SchemaGeneratorDialog.vue?vue&type=template&id=4481c3ee"
import script from "./SchemaGeneratorDialog.vue?vue&type=script&lang=js"
export * from "./SchemaGeneratorDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__